import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { updateFilter } from '../actions/setFilters';
import {
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    makeStyles,
    ListSubheader,
} from '@material-ui/core';

const useStyles = makeStyles({
    root: {
        color: 'var(--grey)',
        backgroundColor: 'var(--side-color)',
        fontFamily: 'Open Sans',
        fontWeight: 700,
        textTransform: 'none',
        marginLeft: '1.1rem',
        marginBottom: '1rem',
        borderRadius: '.3rem',
        '&::before': {
            borderBottom: 'none',
        },
        '& select': {
            padding: '.8rem',
        },
        '& svg': {
            color: 'var(--grey)',
            marginRight: '.5rem',
        },
    },
});

const SortButton = (props) => {
    const classes = useStyles();

    const sort = useSelector((state) => state.filters.sort);
    const dispatch = useDispatch();
    const handleChange = (event) => {
        dispatch(updateFilter('sort', event.target.value));
    };
    return (
        <Select
            value={sort}
            id="sort-select"
            onChange={handleChange}
            renderValue={(value) => `Sort by: ${value}`}
            variant="standard"
            className={classes.root}
            native
        >
            <optgroup label="Name">
                <option value="A-Z">Sort by A-Z</option>
                <option value="Z-A">Sort by Z-A</option>
            </optgroup>
            <optgroup label="Price">
                <option value="Low-High">Sort by Low-High</option>
                <option value="High-Low">Sort by High-Low</option>
            </optgroup>
        </Select>
    );
};

export default SortButton;
